<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="6000"
      absolute
    >
      {{ message }}
      <v-btn dark text @click="snackbar = false"> CLOSE</v-btn>
    </v-snackbar>
    <v-layout mb-1>
      <v-flex xs12>
        <h2 class="white--text">Invoices</h2>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <div
          :class="
            paginatedItems.length === 7 ? 'invoice_box' : 'invoice_box_empty'
          "
        >
          <v-card-text>
            <v-layout>
              <v-flex xs3>
                <span
                  class="accent--text"
                  style="font-size: 14px; font-weight: 700"
                >
                  Confirmed Invoices
                </span>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs3>
                <v-text-field label="Search" v-model="searchQuery" @input="handleSearchInput"></v-text-field>
              </v-flex>
            </v-layout>
            <v-data-table  :headers="confirmedHeaders" :items="filteredList" item-key="id"
                          class="elevation-1" :loading="loading"  hide-default-footer >
              <template v-slot:item="props">
                <tr :key="props.item.id" >
                  <td>{{ props.item?.id }}</td>
                  <td>
                    {{ props.item?.marketer != null ? props.item?.marketer.organisationName : "" }}
                  </td>
                  <td>{{ props.item?.buyer != null ? props.item?.buyer.organisationName : "" }}</td>

                  <td>{{ props.item?.invoiceAmount }}</td>
                  <td>{{ props.item?.dateCreated | prettyDate }}</td>
                  <td>{{ props.item?.status.statusName }}</td>
                  <td  class="actions">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          v-on="on"
                          text
                          icon
                          class="actions"
                        >
                          <v-icon medium> more_horiz</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="viewInvoiceDetails(props.item)">
                          <v-list-item-title> View</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="$can('CAN_UPDATE_INVOICE') && canBeUpdated(props.item)"
                          @click="editInvoiceDetails(props.item)"
                        >
                          <v-list-item-title>Update</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="$can('CAN_DELETE_INVOICE') && canBeDeleted(props.item)"
                          @click="deleteInvoiceDetails(props.item)"
                        >
                          <v-list-item-title>Delete Invoice</v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="triggerDownload(props.item)">
                          <v-list-item-title> Download</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="triggerDownloadWithoutLevy(props.item)">
                          <v-list-item-title> Download without Levy</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="props.item.approvalStatus.id===3 && $can('CAN_APPROVE_UPDATED_INVOICE')"
                                     @click="approveInvoiceDetails(props.item)"
                        >
                          <v-list-item-title> Approve</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="showDeleteInvoiceDetailDialog(props.item)" v-if="$can('CAN_UPDATE_INVOICE') && canBeDeleted(props.item)">
                          <v-list-item-title> Delete</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </template>

            </v-data-table>


            <v-card-actions>
              <v-row>
                <v-col cols="12" sm="9">
                  <v-pagination
                    v-model="page"
                    :length="totalPages"
                    total-visible="numberOfItemsPerPage"
                    next-icon="mdi-menu-right"
                    prev-icon="mdi-menu-left"
                    @input="handlePageChange"
                  ></v-pagination>
                </v-col>
              </v-row>
              <v-spacer></v-spacer>
              <!-- <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span> -->
              <v-spacer></v-spacer>
              <v-pagination
                v-model="page"
                :length="numberOfLinks"
                :total-visible="7"
                color="accent"
              ></v-pagination>
            </v-card-actions>
          </v-card-text>
        </div>
      </v-flex>
      <v-dialog v-model="invoiceDialog" max-width="900">
        <v-card>
          <v-card-title class="title accent--text text-capitalize">
            Invoice Details
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="invoiceHeaders"
              :items="itemInvoices"
              class="mytable"
              hide-default-footer
            >
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="body-2 font-weight-regular accent--text"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.lotNumber }}</td>

                <td>{{ props.item.grade }}</td>
                <td>{{ props.item.bagsBought }}</td>
                <td>{{ props.item.weightBought }}</td>
                <td>{{ props.item.price }}</td>
                <td>{{ props.item.totalValue }}</td>
                <td>{{ props.item.created }}</td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" rounded @click="invoiceDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editInvoiceDialog" max-width="600" :persistent="editInvoiceLoading">
        <v-card>
          <v-card-title class="title accent--text text-capitalize">
            Invoice Details
          </v-card-title>
          <v-card-text>
            <v-progress-linear v-if="editInvoiceLoading" indeterminate color="primary"></v-progress-linear>
            <v-form ref="invoiceForm" :disabled="editInvoiceLoading">
              <v-text-field
                v-model="invoiceId"
                label="Invoice ID"
                outlined
                readonly
              ></v-text-field>
              <v-text-field
                v-model="marketer"
                label="Marketer"
                outlined
                readonly
              ></v-text-field>
              <v-text-field
                v-model="buyer"
                label="Buyer"
                outlined
                readonly
              ></v-text-field>
              <v-text-field
                v-model="value"
                label="Value"
                outlined
                readonly
              ></v-text-field>
              <!-- <v-text-field
            v-model="status"
            label="Status"
            outlined
            required
          ></v-text-field> -->
              <v-select
                v-model="status"
                :items="statusOptions"
                label="Status"
                outlined
                required
                item-text="name"
                item-value="name"
                @change="updateStatusId"
              ></v-select>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submitInvoice" :loading="editInvoiceLoading" :disabled="editInvoiceLoading">Submit</v-btn>
            <v-btn color="primary" @click="closeDialog" :disabled="editInvoiceLoading">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteInvoiceDialog" max-width="600">
        <v-card>
          <v-card-title class="title accent--text text-capitalize">
            Delete Invoice
          </v-card-title>
          <v-card-text>
            <v-form ref="invoiceForm">
              <v-col cols="12" md="6">
                <v-textarea
                  v-model="editedItem.actionComment"
                  label="Deletion Comment"
                  required
                >
                </v-textarea>
              </v-col>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="deleteInvoiceDetail">Delete</v-btn>
            <v-btn color="primary" @click="closeDeleteDialog">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="approveInvoiceDialog" max-width="600" :persistent="approveInvoiceLoading">
        <v-card>
          <v-card-title class="title accent--text text-capitalize">
            Invoice Details
          </v-card-title>
          <v-card-text>
            <v-progress-linear v-if="approveInvoiceLoading" indeterminate color="primary"></v-progress-linear>
            <v-form ref="invoiceForm" :disabled="approveInvoiceLoading">
              <v-text-field
                v-model="invoiceId"
                label="Invoice ID"
                outlined
                readonly
              ></v-text-field>
              <v-text-field
                v-model="marketer"
                label="Marketer"
                outlined
                readonly
              ></v-text-field>
              <v-text-field
                v-model="buyer"
                label="Buyer"
                outlined
                readonly
              ></v-text-field>
              <v-text-field
                v-model="value"
                label="Value"
                outlined
                readonly
              ></v-text-field>
              <v-text-field
                v-model="newstatus"
                label="Status"
                outlined
                readonly
              ></v-text-field>

            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submitapproveInvoice" :loading="approveInvoiceLoading" :disabled="approveInvoiceLoading">Submit</v-btn>
            <v-btn color="primary" @click="rejectInvoice" :loading="approveInvoiceLoading" :disabled="approveInvoiceLoading">Reject</v-btn>
            <v-btn color="primary" @click="closeDialog" :disabled="approveInvoiceLoading">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import _ from 'lodash'

export default {
	name: 'viewinvoice',
	data: function () {
		return {
			invoiceHeaders: [
				{ text: 'Id', value: 'id' },
				{ text: 'lot Number', value: 'lotNumber' },
				{ text: 'Grade', value: 'grade' },
				{ text: 'Bags', value: 'bagsBought' },
				{ text: 'Weight', value: 'weightBought' },
				{ text: 'Price Per Bag', value: 'price' },
				{ text: 'Value(USD)', value: 'totalValue' },
				{ text: 'Invoice Date', value: 'created' }
			],
			confirmedHeaders: [{ text: 'InvoiceID', value: 'id' },
				{ text: 'Marketer.', value: 'marketer' },
				{ text: 'Buyer', value: 'buyerName' },
				{ text: 'Value(USD)', value: 'invoiceAmount' },
				{ text: 'Date', value: 'dateCreated' },
				{ text: 'Status', value: 'statusName' },

				{ text: 'Actions', value: 'actions' }],
			data: [],
			itemInvoices: [],
			singleInvoice: [],
			message: '',
			loading: false,
			pagination: {},
			snackbar: false,
			snackbarColor: '',
			dialog: false,
			paginatedItems: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 10,
			currentPage: 0,
			page: 1,
			invoiceDialog: false,
			editInvoiceDialog: false,
			deleteInvoiceDialog: false,
			approveInvoiceDialog: false,
			search: '',
			totalPages: 0,
			pageSize: 7,
			pageSizes: [5, 10],
			invoiceId: '',
			id: '',
			marketer: '',
			buyer: '',
			value: '',
			status: '',
			statusId: '',
			newstatus: '',
			newstatusId: '',
			searchQuery:'',
			editInvoiceLoading: false,
			approveInvoiceLoading: false,
			editedItem: {
				id: '',
				lotNumber: '',
				actionComment: ''
			},
			statusOptions: [
				// { id: 1, name: "Pending" },
				// { id: 2, name: "Approved" },
				// { id: 3, name: "Rejected" },
				{ id: 7, name: 'PAID' },
				{ id: 9, name: 'PARTIALLY-PAID' },
				{ id: 0, name: 'REJECTED' },
				{ id: 60, name: 'MANUAL_SETTLED_PA' }
				// { id: 5, name: "Completed" },
			]
		}
	},
	mounted () {
		this.getApprovedInvoices(this.currentPage)
		this.permissions = store.state.user.roleId.permissions
	},
	watch: {
		invoices () {
			this.paginatedItems = this.data
		},
		page: function (val) {
			this.paginatedItems = this.getApprovedInvoices(val - 1)
			// this.paginationMethod(
			// 	this.invoices,
			// 	val,
			// 	this.numberOfItemsPerPage
			// )
		}
	},
	computed: {
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedItems // Return all items when search is empty
			} else {
				const searchTerm = this.search.toLowerCase()
				return this.data.filter((result) => {
					var dateCreated = new Date(result.created)
					// Check if the search term is found in any of the columns
					return (
						result.id.toString().includes(searchTerm) ||
            (result.marketerName &&
              result.marketerName.toLowerCase().includes(searchTerm)) ||
            (result.buyerName &&
              result.buyerName.toLowerCase().includes(searchTerm)) ||
            result.invoiceAmount.toString().includes(searchTerm) ||
            // result.dateCreated.toLowerCase().includes(searchTerm) ||
            result.statusName.toLowerCase().includes(searchTerm) ||
            dateCreated.toDateString().toLowerCase().includes(searchTerm)
					)
				})
			}
		}

	},
	methods: {
		handleSearchInput(){
			this.getApprovedInvoices(this.currentPage)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		canBeDeleted (item) {
			return item.status.id === 5 || item.status.id === 4
		},
		canBeUpdated (item) {
			return item.status.id === 7 || item.status.id === 5
		},
		viewInvoiceDetails (item) {
			const url = config.serverURI + '/invoice/getAuctionsByInvoice'
			axios
				.post(url, item)
				.then((response) => {
					// const { items, totalPages, totalItems } = response.data
					this.itemInvoices = response.data
					this.itemInvoices.forEach((invoice) => {
						if (invoice.created) {
							const date = new Date(invoice.created)
							const formattedDate = `${date.getFullYear()}-${(
								date.getMonth() + 1
							)
								.toString()
								.padStart(2, '0')}-${date
								.getDate()
								.toString()
								.padStart(2, '0')} ${date
								.getHours()
								.toString()
								.padStart(2, '0')}:${date
								.getMinutes()
								.toString()
								.padStart(2, '0')}:${date
								.getSeconds()
								.toString()
								.padStart(2, '0')}`
							// const date = new Date(invoice.created)
							invoice.created = formattedDate // You can update the 'created' property in the invoice object with the formatted date.
						}
					})
					this.itemInvoices = response.data
					this.invoiceDialog = true
				})
				.catch((error) => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.itemInvoices
			// this.itemInvoices = item.auctionResults.map(result => {
			//   return { ...result, created: formattedDate } // Add the formatted date to each item
			// })
		},
		deleteInvoiceDetails (item) {
			const url = config.serverURI + '/invoice/deleteInvoice'
			axios
				.post(url, item)
				.then((response) => {
					const invoiceDetails = response.data
					console.log('Invoice>>>>>', response.data)

					// Set values for the new fields
					this.invoiceId = invoiceDetails.id
					this.marketer = invoiceDetails.marketer.organisationName
					this.buyer = invoiceDetails.buyer.organisationName
					this.value = invoiceDetails.invoiceAmount
					this.statusId= invoiceDetails.status.id

					this.message = 'Invoice Deleted Successfully'
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.getApprovedInvoices(this.currentPage)
				})
				.catch((error) => {
					// Handle error
					console.error('Error fetching invoice checkoffSettlementDetails:', error)
					this.message = error.response.data.message
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},

		editInvoiceDetails (item) {
			// Use data directly from item to avoid extra API call
			this.invoiceId = item.id
			this.marketer = item.marketer.organisationName || ''
			this.buyer = item.buyer.organisationName || ''
			this.value = item.invoiceAmount
			this.statusId= item.status.id
			this.status = item.status.statusName

			// Ensure the current status is included in statusOptions using a Set for O(1) lookup
			const statusIdSet = new Set(this.statusOptions.map(opt => opt.id))
			if (!statusIdSet.has(item.status.id)) {
				this.statusOptions.push({
					id: item.status.id,
					name: item.status.statusName
				})
			}

			// Open the dialog
			this.editInvoiceDialog = true
		},
		approveInvoiceDetails (item) {
			// Use data directly from item to avoid extra API call
			this.invoiceId = item.id
			this.marketer = item.marketer.organisationName || ''
			this.buyer = item.buyer.organisationName || ''
			this.value = item.invoiceAmount
			this.statusId= item.status.id
			this.status = item.status.statusName

			// Set the new status for approval (assuming next status is available or use a default)
			// You may need to adjust this based on your business logic
			this.newstatus = item.newStatus.statusName // or get from item if available
			this.newstatusId = item.newStatus.id
			 // Adjust based on what the new status ID should be

			// Open the dialog
			this.approveInvoiceDialog = true
		},
		submitInvoiceDetails (formData) {
			const url = config.serverURI + '/invoice/editInvoice'
			axios
				.post(url, formData)
				.then((response) => {
					// Handle success (e.g., show a success message, update UI)
					console.log('Invoice submitted successfully', response.data)
					this.message = 'Invoice submitted successfully'
					this.snackbar = true
					this.snackbarColor = 'success'
					this.getApprovedInvoices(this.currentPage)

					// Close the dialog after successful submission
					this.$refs.invoiceForm.reset()
					this.editInvoiceDialog = false
					this.editInvoiceLoading = false
				})
				.catch((error) => {
					// Handle error
					console.error('Error submitting invoice:', error)
					this.message = 'Error submitting invoice'
					this.snackbar = true
					this.snackbarColor = 'error'
					this.editInvoiceLoading = false
				})
		},
		rejectInvoiceDetails (formData) {
			const url = config.serverURI + '/invoice/rejectUpdatedInvoice'
			axios
				.post(url, formData)
				.then((response) => {
					// Handle success (e.g., show a success message, update UI)
					console.log('Invoice submitted successfully', response.data)
					this.message = 'Invoice submitted successfully'
					this.snackbar = true
					this.snackbarColor = 'success'
					this.getApprovedInvoices(this.currentPage)

					// Close the dialog after successful submission
					this.$refs.invoiceForm.reset()
					this.approveInvoiceDialog = false
					this.approveInvoiceLoading = false
				})
				.catch((error) => {
					// Handle error
					console.error('Error submitting invoice:', error)
					this.message = 'Error submitting invoice'
					this.snackbar = true
					this.snackbarColor = 'error'
					this.approveInvoiceLoading = false
				})
		},
		submitapproveInvoiceDetails (formData) {
			const url = config.serverURI + '/invoice/approveInvoice'
			axios
				.post(url, formData)
				.then((response) => {
					// Handle success (e.g., show a success message, update UI)
					console.log('Invoice submitted successfully', response.data)
					this.message = 'Invoice submitted successfully'
					this.snackbar = true
					this.snackbarColor = 'success'
					this.getApprovedInvoices(this.currentPage)

					// Close the dialog after successful submission
					this.$refs.invoiceForm.reset()
					this.approveInvoiceDialog = false
					this.approveInvoiceLoading = false
				})
				.catch((error) => {
					// Handle error
					console.error('Error submitting invoice:', error)
					this.message = 'Error submitting invoice'
					this.snackbar = true
					this.snackbarColor = 'error'
					this.approveInvoiceLoading = false
				})
		},
		showDeleteInvoiceDetailDialog (item) {
			this.deleteInvoiceDialog = true
			this.editedItem.id = item.id
			this.editedItem.lotNumber = item.lotNumber
			this.editedItem.actionComment = item.actionComment
		},
		deleteInvoiceDetail () {
			const url = config.serverURI + '/invoice/deleteInvoice'
			axios.post(url, this.editedItem)
				.then(response => {
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.deleteInvoiceDialog = false
					this.getApprovedInvoices(this.currentPage)
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = error.response.data.message === null ? error.response.status : error.response.data.message
					this.snackbar = true
					this.snackbarColor = 'error'
					this.deleteInvoiceDialog = false
				})
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		getRequestParams (name, page, pageSize) {
			const params = {}
			// if (page) {
			params.page = page
			params.query = this.searchQuery			// - 1
			// }
			// if (pageSize) {
			params.size = pageSize
			// }
			if (name) {
				params.eslipNumber = name
			}
			return params
		},
		updateStatusId (selectedStatus) {
			const selectedStatusObject = this.statusOptions.find(
				(option) => option.name === selectedStatus
			)

			if (selectedStatusObject) {
				this.statusId= selectedStatusObject.id
			} else {
				// Handle the case where the selectedStatus is not found in statusOptions
				// console.error('Selected status not found:', selectedStatus)
			}
		},
		getApprovedInvoices (val) {
			this.loading = true
			const params = this.getRequestParams(
				this.searchQuery,
				val,
				this.numberOfItemsPerPage
			)
			const url = config.serverURI + '/invoice/approved'
			axios
				.get(url, { params })
				.then((response) => {
					this.paginatedItems = response.data.content
					// this.invoices = response.data.content
          console.log('invoices - ', this.invoices)
					this.numberOfLinks = response.data.page.totalPages
					this.numberOfItemsPerPage = response.data.page.size
					this.currentPage = response.data.page.number
					this.loading = false
				})
				.catch((error) => {
					// Request failed.
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
					this.loading = false
				})
			return this.data
		},
		handlePageChange (value) {
			this.page = value
			this.getApprovedInvoices()
		},
		handlePageSizeChange (size) {
			this.pageSize = size
			this.page = 1
			this.getApprovedInvoices()
		},
		created: function () {
			this.debouncedGetAnswer = _.debounce(this.getSettlements, 1000)
		},
		showInvoices (item) {
			this.dialog = true
			this.itemInvoices = item.auctionResults
		},
		triggerDownload (item) {
			console.log(item.data)
			const url = config.serverURI + '/invoice/download'
			axios({ url: url, method: 'POST', responseType: 'blob', data: item })
				.then((response) => {
					const url = window.URL.createObjectURL(
						new Blob([response.data], { type: 'application/pdf' })
					)
					const link = document.createElement('a')
					link.href = url
					const itemFileName = item.buyer.organisationName + '_' + item.dateCreated + '.pdf'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch((error) => {
					// Request failed.
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		triggerDownloadWithoutLevy (item) {
			console.log(item.data)
			const url = config.serverURI + '/invoice/downloadWithNoLevy'
			axios({ url: url, method: 'POST', responseType: 'blob', data: item })
				.then((response) => {
					const url = window.URL.createObjectURL(
						new Blob([response.data], { type: 'application/pdf' })
					)
					const link = document.createElement('a')
					link.href = url
					const itemFileName = item.buyer.organisationName + '_' + item.dateCreated + '.pdf'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch((error) => {
					// Request failed.
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		submitInvoice () {
			console.log('Status before submitting>>>', this.status)
			const formData = {
				id: this.invoiceId,
				marketerName: this.marketer,
				buyerName: this.buyer,
				invoiceAmount: this.value,
				statusName: this.status,
				statusId: this.statusId// Assuming this property corresponds to the selected status
				// Add other form fields as needed
			}
			this.editInvoiceLoading = true
			this.submitInvoiceDetails(formData)
		},
		rejectInvoice () {
			const formData = {
				id: this.invoiceId,
				marketerName: this.marketer,
				buyerName: this.buyer,
				invoiceAmount: this.value,
				statusName: this.status,
				statusId: this.statusId// Assuming this property corresponds to the selected status
				// Add other form fields as needed
			}
			console.log('formData>>>>', formData)
			this.approveInvoiceLoading = true
			this.rejectInvoiceDetails(formData)
		},
		submitapproveInvoice () {
			console.log('Status before submitting>>>', this.status)
			const formData = {
				id: this.invoiceId,
				marketerName: this.marketer,
				buyerName: this.buyer,
				invoiceAmount: this.value,
				statusName: this.newstatus,
				statusId: this.newstatusId // Assuming this property corresponds to the selected status
				// Add other form fields as needed
			}
			console.log('formData>>>>', formData)
			this.approveInvoiceLoading = true
			this.submitapproveInvoiceDetails(formData)
		},
		closeDialog () {
			// Reset form values and close the dialog
			this.$refs.invoiceForm.reset()
			this.editInvoiceDialog = false
		},
		closeDeleteDialog () {
			// Reset form values and close the dialog
			this.$refs.invoiceForm.reset()
			this.deleteInvoiceDialog = false
		}
	}
}
</script>
<style>
.mytable .v-table tbody tr:not(:last-child) {
  border-bottom: none;
}

.invoice_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.invoice_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.invoice_box:after,
.invoice_box:before {
  right: 100%;
  top: 39%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.invoice_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.invoice_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.tabs {
  font-weight: 600;
  font-color: #4e4e4e;
}

.loader {
  font-weight: 600;
  font-color: #4e4e4e;
  margin: 10px;
  font-size: 20px;
}
</style>
